import { AlertController, Events, NavController } from 'ionic-angular';
import { OnInit } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicPage, ModalController } from 'ionic-angular';
import { MultipleAccountBloc } from '../../../../bloc/authentication/multiple-account.bloc';
import { AlertServiceProvider } from '../../../../providers/alert-service/alert-service';
import { TranslateService } from '@ngx-translate/core';
import { Messages } from '../../../../helpers/messages';
import { AppPreferences } from '../../../../shared/local/app-preferences.local';
import { EventLabel } from '../../../../helpers/event-label';
import { MultipleAccount } from '../../../../shared/nestjs/gd-only/dto/multiple-acocunt.dto';

/**
 * Generated class for the ListMultiAccountPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'list-multi-account',
  templateUrl: 'list-multi-account.html',
})
export class ListMultiAccountPage implements OnInit {

  @Input() switchAccount: boolean = false;
  @Input() parentIsRoot: boolean = false;
  @Input() showRemoveAllAccount = false;
  @Input() isFromSwitchPage = false;
  @Input() desktop: boolean = false;
  @Output() switchAccountChange = new EventEmitter();
  @Output() selectedAccount = new EventEmitter();

  public dataAccount = [];
  public canGoBack: boolean;
  public dataAccountTemp: any;
  public removeAllLoading: boolean = false;
  public removeAccountLoading: boolean = false;
  public isSwitchProcessing = false;

  constructor(
    public events: Events,
    private modalCtrl: ModalController,
    private multipleAccountBloc: MultipleAccountBloc,
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public alertServiceProvider: AlertServiceProvider,
    public translate: TranslateService,
    private appPreferences: AppPreferences
  ) {
  }

  async ngOnInit() {
    if (this.navCtrl.first().id === 'SwitchAccountPage') {
      this.canGoBack = false;
    } else {
      this.canGoBack = this.navCtrl.canGoBack();
    }

    this.dataAccount = await this.multipleAccountBloc.getListAccount();
    this.initEvents(this.dataAccount);
  }

  initEvents(data: any[]) {
    this.events.subscribe('multiaccount:switchdone', () => {
      this.isSwitchProcessing = false;
      this.dataAccount = data.map((item) => {
        item.loading = false;
        return item;
      })
    });
  }

  async swicthAccount(item: MultipleAccount) {
    try {
      this.isSwitchProcessing = true;

      item.loading = true;
      await this.multipleAccountBloc.switch(item);
      if ((!this.parentIsRoot || window.innerWidth >= 768) && !this.isFromSwitchPage) {
        this.events.publish(EventLabel.SWITCH_ACCOUNT_RELOAD, item);
      } else {
        // handle switch dari switch page
        this.selectedAccount.emit(item);
      }
    } catch (error) {
      console.log('error', error);
      item.loading = false;
      this.isSwitchProcessing = false;
    }
  }

  back() {
    this.navCtrl.pop();
  }

  addAnotherAccount() {
    if (this.switchAccount) {
      this.switchAccountChange.emit(false);
    } else {
      if (window.innerWidth < 768) {
        const modal = this.modalCtrl.create(
          'SwitchAccountPage', {},
          {
            cssClass: 'grd-modal-multiaccount'
          }
        );

        // modal.onDidDismiss(async () => this.dataAccount = await this.multipleAccountBloc.dataAccount())
        modal.present();
      } else {
        const modal = this.modalCtrl.create(
          'AddAnoutherAccountPage', { isDesktop: true },
          {
            cssClass: 'grd-modal-multiaccount'
          }
        );
        modal.present();
      }
    }
  }

  async removeAllAccount() {
    const confirm = await this.alertServiceProvider.confirmMola(Messages.CONFIRM_REMOVE_ALL_ACCOUNT);
    if (confirm) {
      this.removeAllLoading = true;
      const multipleAccount = await this.appPreferences.getMultipleAccount();
      const auth = await this.appPreferences.getAuth();
      for await (let account of multipleAccount) {
        await this.multipleAccountBloc.clearAccount(account.gopathNew, account.id);
      }

      this.dataAccount = [];
      this.removeAllLoading = false;
      await this.appPreferences.setMultipleAccount(this.dataAccount);

      // redirect ke login page
      if (!auth.id) {
        this.navCtrl.setRoot("Login2Page");
      }
    }
  }

  async removeAccount(data: any) {
    const confirm = await this.alertServiceProvider.confirmMola(Messages.CONFIRM_REMOVE_ACCOUNT);
    if (confirm) {
      try {
        data.loading = true;
        const multipleAccount = await this.appPreferences.getMultipleAccount();
        const auth = await this.appPreferences.getAuth();
        const idx = multipleAccount.findIndex(item => (item.empId === data.empId && item.companyCode === data.companyCode));


        // logout account
        await this.multipleAccountBloc.clearAccount(data.gopathNew, data.id);
        data.loading = false;

        if (idx !== -1) {
          // hapus data akun yang di hapus
          multipleAccount.splice(idx, 1);

          // tampilkan data muliple account selain akun yg sedang login
          this.dataAccount = multipleAccount.filter((item) => item.empId !== auth.empId);

          // set ulang mulipleAccount di storage
          await this.appPreferences.setMultipleAccount(multipleAccount);
          // redirect ke login page
          if (!auth.id && multipleAccount.length == 0) {
            this.navCtrl.setRoot("Login2Page");
          }
        }
      } catch (error) {
        data.loading = false;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/general/home2/list-multi-account/list-multi-account.ts